import React, { PureComponent } from 'react';
import gettext from 'js-utils/gettext';

import ValidationFormField from 'eventbrite_design_system/validationFormField/ValidationFormField';
import InputField from 'eventbrite_design_system/inputField/InputField';

import { shouldDisplayError } from 'js-utils/redux';

export default class ConfirmEmailField extends PureComponent {
    _handlePaste(e) {
        // Avoid paste in input
        e.preventDefault();
    }

    render() {
        return (
            <div className="eds-l-mar-bot-4">
                <ValidationFormField
                    name="confirmEmail"
                    label={gettext('Confirm email')}
                    shouldDisplayError={shouldDisplayError}
                    v2={true}
                >
                    <InputField
                        id="confirmEmail"
                        name="confirmEmail"
                        autoFocus={true}
                        onPaste={this._handlePaste}
                        label={gettext('Confirm email')}
                        type="email"
                        role="textbox"
                    />
                </ValidationFormField>
            </div>
        );
    }
}
